import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: {
    users: [],
    loading: false
  },
  mutations: {
    setUsers(state, payload) {
      state.users = payload;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  },
  actions: {
    async fetchUsers({ commit }) {
      console.log("[cidUsers] fetchUsers() called");
      commit('setLoading', true);
      try {
        const res = await axios.admin.get('/user/cid-submissions');
        console.log("[cidUsers] API success", res.data);
        commit('setUsers', res.data.data);
      } catch (e) {
        console.error("[cidUsers] API error", e);
      }
      commit('setLoading', false);
    },

    async approveSurvey(_, surveyId) {
      console.log("[cidUsers] approving survey ID:", surveyId);
      return axios.admin.post(`/user/cid-submissions/${surveyId}/approve`);
    }
  }
}